import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {DialogAction} from '../../../../shared/contracts/dialog.interface';
import {ChatComponent} from '../../../../conversations/components/chat/chat.component';
import {Conversation} from '../../../../conversations/contracts/conversation.interface';

@Component({
  selector: 'kc-chat-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    ChatComponent
  ],
  templateUrl: './chat-dialog.component.html',
  styleUrl: './chat-dialog.component.scss'
})
export class ChatDialogComponent implements OnDestroy, OnInit {
  conversation: Conversation = {} as Conversation;
  constructor(private ref: DynamicDialogRef, private config: DynamicDialogConfig) {
  }

  static readonly DIALOG_CONFIG: DynamicDialogConfig = {
    header: 'Chat',
    width: '95vw',
    style: {'max-width': '800px', height: '85vh'},
    modal: true,
    focusOnShow: false,
    closable: true
  };

  ngOnInit() {
    if(this.config.data){
      this.conversation = this.config.data;
    }
  }


  closeDialog(){
    this.ref.close({
      action: DialogAction.CLOSE,
    });
  }

  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
  }
}
